import { combineReducers } from "redux";
import createProposalReducer from "../../reduxSlices/modal/createProposalSlice";

const modalReducer = combineReducers({
    createProposalModalContent: createProposalReducer
});

export default modalReducer;
